interface Props {
  cssClass?: string;
  children: any;
}

const BtnToolbar = ({ cssClass, children }: Props) => {
  const css = cssClass ?? '';

  return (
    <div className={`btn-toolbar d-flex justify-content-between ${css}`.trim()} role="toolbar">
      {children}
    </div>
  );
};

export { BtnToolbar };
